import React, { useContext, useEffect, useState } from 'react'
import './Wallet.css'
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import { GetUserWalletAmount, GetWalletTransactionList } from '../../ApiServices/UserWallet/UserWalletApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import dayjs from 'dayjs';
import DownloadApp from '../DownLoadApp/DownloadApp';
const WalletList = () => {
    const [transactionData, setTransactionData] = useState([])
    const { setLoader } = useContext(LoaderContext);
    const userID = localStorage.getItem("userID")
    const [walletAmount, setWalletAmount] = useState(0)
    const data = [
        {
            date: '25/05/25',
            Description: 'Desc',
            debitAmount: 2500,
            creditAmount: 300,
            balanceAmount: 12000
        }, {
            date: '25/05/25',
            Description: 'Desc',
            debitAmount: 2500,
            creditAmount: 300,
            balanceAmount: 12000
        }, {
            date: '25/05/25',
            Description: 'Desc',
            debitAmount: 2500,
            creditAmount: 300,
            balanceAmount: 12000
        }, {
            date: '25/05/25',
            Description: 'Desc',
            debitAmount: 2500,
            creditAmount: 300,
            balanceAmount: 12000
        },
    ]
    useEffect(() => {
        GetWalletTransactionListData();
        GetUserWalletAmountData();
    }, [])
    const GetUserWalletAmountData = async () => {

        setLoader(true);
        try {
            let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);
                const list = response?.DATA || [];
                setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)
            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };

    const GetWalletTransactionListData = async () => {
        setLoader(true);
        try {
            let response = await GetWalletTransactionList(userID); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);
                const list = response?.DATA || [];
                setTransactionData(list)
                console.log('data', list)

            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };


    return (
        <>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${EstoreBannerImg})` }}></div>
                <div className="container" >
                    <h2 className="page-header__title bw-split-in-left">My Wallet</h2>
                </div>
            </section>
            <div className="wallet-history-section">
                {/* Wallet Header remains same */}
                <div className="wallet-balance">
                    {/* <h3 className="wallet-heading">My Wallet</h3> */}
                    <div className="balance-box">
                        <i className="icofont-wallet wallet-icon"></i>
                        <div className="vertical-bar"></div>
                        <span className="amount fw-bold">₹ {walletAmount}</span>
                    </div>
                    <p className="wallet-subtext">(Available Wallet Balance)</p>
                    {walletAmount === 0 && (
                        <div style={{ width: '100%', justifyContent: 'center' }}>
                            <h3 className='text-muted col-12 text-center' style={{ fontWeight: '600', color: 'grey' }}>Your Wallet is Empty!</h3>
                            <p className='text-center wallet-paragraph-css' >
                                Don't worry — you can earn wallet credits easily.
                                Download the app and share it with your friends.
                                When they sign up and book a service or puja, you'll receive wallet rewards instantly!
                                Start sharing and get rewarded today.

                            </p>
                        </div>
                    )}
                </div>


                {/* Transaction History Table */}
                <div className="wallet-table-wrapper">
                    {transactionData?.length > 0 ? (
                        <div className='card p-3'>
                            <div className="table-responsive">
                                <table className="wallet-table ">
                                    <thead>
                                        <tr >
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Debit Amount (₹)</th>
                                            <th>Credit Amount (₹)</th>
                                            <th>Bal. Amount (₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactionData?.map((value, index) => (
                                            <tr key={index}>
                                                <td>{dayjs(value.RegDate).format('DD/MM/YYYY') || 'N/A'}</td>
                                                <td>{value.Description || 'N/A'}</td>
                                                <td>{value.Debit?.toFixed(2) || '0.00'}</td>
                                                <td>{value.Credit?.toFixed(2) || '0.00'}</td>
                                                <td>{value.Amount?.toFixed(2) || '0.00'}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>

                        </div>

                    ) : ''}

                </div>

            </div >
            <DownloadApp />

        </>
    )
}

export default WalletList
